module.exports = {
      id: "icon-a-equipment-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-a-equipment",
      toString: function () {
        return this.url;
      }
    }